<template>
    <div class="ExpertProfile">
        <el-card class="expert-detail-card">
            <div class="profile-section text-center">
                <div class="relative">
                    <img
                        class="profile-pic"
                    />

                   

                    <!-- <div class="rank-wrapper" v-if="expertProfile.rank">
                        <Hexagon :rank="expertProfile.rank"></Hexagon>
                    </div> -->
                </div>

                <div class="profile-details-section">
                    <div class="font-09rem font-weight-600 top-margin-10 capitalize">
                        {{ expertProfile.name }}
                    </div>
                    <div class="input-label-gray top-margin-5">{{ expertProfile.profession }}</div>
                    <div class="input-label-gray" v-if="expertProfile.profession != 'Student'">{{ expertProfile.company }}</div>
                    <div class="input-label-gray" v-if="expertProfile.profession == 'Student'">{{ expertProfile.institute_name }}</div>

                    <!-- <el-rate class="top-margin-5" v-model="expertProfile.overall_rating" disabled></el-rate> -->


                    <div v-if="$router.currentRoute.path != '/my-account'">
                        <div class="more-details-section top-margin-10">
                            <div v-if="expertProfile.annual_roi">
                                <div class="label-xs-bold" style="font-weight: 600;">
                                    {{ expertProfile.annual_roi ? expertProfile.annual_roi + '%' : 'NA' }}
                                </div>
                                <span class="input-label-bold-gray" style="font-size: 11px;">
                                   Avg ROI
                                </span>
                            </div>
                        </div>

                        <div class="more-details-section top-margin-5">
                            <!-- <div>
                                <div class="label-xs-bold" style="font-weight: 600;">
                                    {{ expertProfile.accuracy ? expertProfile.accuracy + '%' : 'NA' }}
                                </div>
                                <span class="input-label-bold-gray" style="font-size: 11px;">
                                    Accuracy
                                </span>
                            </div>
                            <div>
                                <div class="label-xs-bold" style="font-weight: 600;">
                                    {{ expertProfile.success_rate ? expertProfile.success_rate : 0 }}%
                                </div>
                                <span class="input-label-bold-gray" style="font-size: 11px;">Success Rate</span>
                            </div> -->
                        </div>

                        <div class="more-details-section top-margin-5">
                            <div>
                                <div class="label-xs-bold primary-theme-color" style="font-weight: 600;">
                                    {{ expertProfile.live_reco ? expertProfile.live_reco : 0 }}
                                </div>
                                <span class="input-label-bold-gray" style="font-size: 11px;">Live Reco </span>
                            </div>
                            <div>
                                <div class="label-xs-bold" style="font-weight: 600;">
                                    {{ expertProfile.total_reco ? expertProfile.total_reco : 0 }}
                                </div>
                                <span class="input-label-bold-gray" style="font-size: 11px;">Total Reco</span>
                            </div>
                        </div>

                        <!-- <div class="more-details-section top-margin-5">
                            <div>
                                <div class="label-xs-bold" style="font-weight: 600;">
                                    {{ expertProfile.following ? expertProfile.following : 0 }}
                                </div>
                                <span class="input-label-bold-gray" style="font-size: 11px;">Following</span>
                            </div>
                            <div>
                                <div class="label-xs-bold" style="font-weight: 600;">
                                    {{ expertProfile.follower ? expertProfile.follower : 0 }}
                                </div>
                                <span class="input-label-bold-gray" style="font-size: 11px;">Followers</span>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import { serverAddr, serverHostName } from "../networkConfig";
import Hexagon from "@/components/Hexagon.vue";
import { EventBus } from '../eventBus';

export default {
    name: 'ExpertProfile',

    props: ['expert_id'],

    components: {
        Hexagon
    },

    data() {
        return {
            serverHostName: serverHostName,
            is_expert_profile_loading: false
        };
    },

    mounted() {
        // checked that is data already stored in global store
        // if(!Object.keys(this.expertProfile).length || !this.expertProfile.name){
        //     this.getExpretsDetails();
        // }

        // EventBus.$on('resetExpertDetails', () =>{
        //     this.getExpretsDetails();
        // })
    },

    methods: {
        //get experts details
        getExpretsDetails() {
            this.is_expert_profile_loading = true;  //enabled loader
            serverAddr
            .post("/performers/v1/expert/profile", {
                user_id: this.expert_id
            })
            .then(response => {
                if (response.data.status) {
                    if(response.data.data.length){
                        this.$store.commit('commitExpertDetails', response.data.data[0]);
                    }
                }
                this.is_expert_profile_loading = false;  //disabled loader
            })
            .catch((error) => {
                console.log(error);
                this.is_expert_profile_loading = false;  //disabled loader
            });
        },
    },

    beforeDestroy() {
        EventBus.$off();
    },

    computed: {
        //returns stored user profile from local storage
        expertProfile() {
            return this.$store.state.expert_details;
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.ExpertProfile {
    .expert-detail-card {
        margin: 30px 25px;
        border-radius: 9px;
    }
    .profile-section{
        padding: 20px;
        height: 265px;
    }
    .profile-pic {
        height: 60px;
        width: 60px;
        object-fit: cover;
        border-radius: 100%;
    }
    .rank-wrapper {
        position: absolute;
        bottom: -8px;
        right: 0;
        left: 0;
    }
    .profile-details-section{
        .title{
            font-size: 1rem;
            font-weight: 600;
            color: #000;
        }
    }
    .performer-rating{
        i{
            font-size: 1rem;
            color: #ffcc00;
        }
    }
    .portfolio-rating{
        i{
            font-size: 1rem;
            color: #1870cb;
            // color: $secondary-theme-color;
        }
    }
    .more-details-section {
        display: flex;
        justify-content: space-around;
    }
    .bottom{
        background: #eceff4;
        padding: 10px;
        text-align: center;
    }
}
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";
.ExpertProfile {
    .el-card__body {
        padding: 0px;
    }
}
</style>
